import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export function useDashboard() {
    const [result, setResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate()

    const fetchData = useCallback(async () => {
        setIsLoading(true);

        try {
            const { data } = await api.get('/btck/info/dashboard');
            if (data) {
                setResult(data);
            } else {
                setResult({ data: 'ERR', message: 'Sem conexão com o servidor!' });
                navigate('/login');
            }
        } catch {
            setResult({ data: 'ERR', message: 'Sem conexão com o servidor!' });
        } finally {
            setIsLoading(false);
        }
    }, [navigate]);

    return { result, fetchData, isLoading };
}
